/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { getHtmlTagDefinition } from "./html_tags.js";
import { Parser } from "./parser.js";
export class HtmlParser extends Parser {
    constructor() {
        super(getHtmlTagDefinition);
    }
    parse(source, url, options, isTagNameCaseSensitive = false, getTagContentType) {
        return super.parse(source, url, options, isTagNameCaseSensitive, getTagContentType);
    }
}
